import { useState } from 'react';

function usePagination(itemsPerPage, totalItems) {
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return {
        currentPage,
        setCurrentPage,
        totalPages,
        goToNextPage,
        goToPreviousPage,
    };
}

export default usePagination;